import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import staticContent from "../data/content.json";

const ContentContext = createContext(null);

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(staticContent);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setContent(staticContent);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6f2ec]" data-testid="content-loading">
        <div className="text-center">
          <div className="font-logo text-[#23211e] text-[22px] tracking-[0.16em]">FLETCHER &amp; STONE</div>
          {error ? (
            <p className="font-body text-[13px] text-[#94664f] mt-4">Unable to load content. Please refresh.</p>
          ) : (
            <div className="mt-6 mx-auto w-8 h-8 border-2 border-[#94664f] border-t-transparent rounded-full animate-spin" />
          )}
        </div>
      </div>
    );
  }

  return (
    <ContentContext.Provider value={{ ...content, refresh: load }}>{children}</ContentContext.Provider>
  );
}
